import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../../constants';
import RowTransaction from '../RowTransaction';
const EditMultipleListRow = ({ item, readonly, selected, onSelected, isLastItem, isFirstItem, }) => {
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => {
        const out = [];
        if (isLastItem) {
            out.push(styles.lastItem);
            if (!readonly && isWeb)
                out.push(styles.padBottom);
        }
        if (isFirstItem) {
            out.push(styles.firstItem);
            if (!readonly && isWeb)
                out.push(styles.padTop);
        }
        return out;
    }, [isLastItem, isFirstItem, styles, readonly]);
    return (<View style={[styles.wrapper, borderStyles]}>
      <RowTransaction showDate item={item} backgroundDark disabled={readonly} selected={!readonly && selected} onPress={onSelected} isEditingTransactions={!readonly} btnStyles={borderStyles}/>
    </View>);
};
export default memo(EditMultipleListRow);
const styleSet = createStyleSheets((colors) => ({
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    padTop: {
        paddingTop: rem(8),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
    padBottom: {
        paddingBottom: rem(8),
    },
}));
